// ===========================================================
// ERP VENDOR MODULE - Admin Management (COMPLETE VERSION)
// ===========================================================

const VENDOR_CURRENCY = 'AED';

class VendorAdmin {
  constructor() {
    this.init();
  }

  init() {
    this.loadPendingVendors();
    this.loadPendingProducts();
    this.loadAllVendors();
    this.updateStats();
    console.log("Vendor Admin Initialized");
  }

  refreshData() {
    this.loadPendingVendors();
    this.loadPendingProducts();
    this.loadAllVendors();
    this.updateStats();
  }

  loadPendingVendors() {
    const vendors = JSON.parse(localStorage.getItem('shopify_vendors') || '[]');
    const pending = vendors.filter(v => v.status === 'pending');
    
    const container = document.getElementById('pending-vendors-list');
    if (!container) return;
    
    if (pending.length === 0) {
      container.innerHTML = '<p style="text-align:center; color:#9ca3af; padding:20px;">No pending vendor requests</p>';
      this.updateVendorBadge(0);
      return;
    }

    container.innerHTML = pending.map(v => `
      <div style="border:1px solid #e5e7eb; padding:20px; margin:10px 0; border-radius:12px; background:white;">
        <div style="display:flex; justify-content:space-between; align-items:start; flex-wrap:wrap; gap:15px;">
          <div style="flex:1;">
            <div style="font-weight:bold; font-size:18px; color:#1f2937; margin-bottom:5px;">${v.storeName || 'Unknown Store'}</div>
            <div style="font-size:14px; color:#6b7280; margin-bottom:3px;">📧 ${v.email || 'N/A'}</div>
            <div style="font-size:14px; color:#6b7280; margin-bottom:3px;">📱 ${v.phone || 'N/A'}</div>
            <div style="font-size:13px; color:#f59e0b; margin-top:8px; font-weight:600;">
              Commission: ${v.commission || 0}% | Applied: ${v.joinedDate || new Date(v.createdAt).toLocaleDateString()}
            </div>
          </div>
          <div style="display:flex; gap:10px;">
            <button onclick="window.vendorAdmin.approveVendor('${v.id}')" 
              style="background:#10b981; color:white; border:none; padding:10px 20px; border-radius:8px; cursor:pointer; font-weight:600;">
              ✅ Approve
            </button>
            <button onclick="window.vendorAdmin.rejectVendor('${v.id}')" 
              style="background:#ef4444; color:white; border:none; padding:10px 20px; border-radius:8px; cursor:pointer; font-weight:600;">
              ❌ Reject
            </button>
          </div>
        </div>
      </div>
    `).join('');
    
    this.updateVendorBadge(pending.length);
  }

  loadPendingProducts() {
    const products = JSON.parse(localStorage.getItem('vendor_products') || '[]');
    const pending = products.filter(p => p.status === 'pending');
    const vendors = JSON.parse(localStorage.getItem('shopify_vendors') || '[]');
    
    const container = document.getElementById('pending-products-list');
    if (!container) return;
    
    if (pending.length === 0) {
      container.innerHTML = '<p style="text-align:center; color:#9ca3af; padding:20px;">No pending products</p>';
      return;
    }

    container.innerHTML = pending.map(p => {
      const vendor = vendors.find(v => 
        v.id === p.vendorId || 
        v.vendorId === p.vendorId || 
        String(v.id) === String(p.vendorId)
      );
      
      const safeVariants = (p.variants || []).map(v => ({
        size: v.size || 'N/A',
        color: v.color || 'N/A',
        vendorPrice: parseFloat(v.vendorPrice) || 0,
        customerPrice: parseFloat(v.customerPrice) || 0,
        stock: parseInt(v.stock) || 0,
        sku: v.sku || 'N/A'
      }));
      
      const avgPrice = safeVariants.length > 0 
        ? safeVariants.reduce((sum, v) => sum + v.vendorPrice, 0) / safeVariants.length 
        : 0;
      const avgCustomerPrice = safeVariants.length > 0 
        ? safeVariants.reduce((sum, v) => sum + v.customerPrice, 0) / safeVariants.length 
        : 0;
      
      const commission = avgCustomerPrice - avgPrice;
      const vendorName = vendor ? (vendor.storeName || vendor.name || 'Unknown') : 'Unknown';
      
      return `
      <div style="border:1px solid #e5e7eb; padding:20px; margin:10px 0; border-radius:12px; background:white;">
        <div style="display:flex; justify-content:space-between; align-items:start; margin-bottom:15px;">
          <div style="display:flex; gap:15px; flex:1;">
            ${(p.images || []).slice(0,3).map(img => `
              <img src="${img}" onerror="this.src='${NO_IMAGE}'" style="width:80px; height:80px; object-fit:cover; border-radius:8px; border:1px solid #e5e7eb;">
            `).join('')}
          </div>
          <button onclick="window.vendorAdmin.deleteLocalProduct('${p.id}')" 
            style="background:#6b7280; color:white; border:none; padding:8px 16px; border-radius:6px; cursor:pointer; font-size:12px; margin-left:10px;"
            title="Remove from local storage">
            🗑️ Remove Local
          </button>
        </div>
        
        <div style="margin-bottom:15px;">
          <div style="font-weight:bold; font-size:16px; color:#1f2937; margin-bottom:5px;">${p.title || 'Untitled Product'}</div>
          <div style="font-size:13px; color:#6b7280; margin-bottom:3px;">
            By: <b style="color:#3b82f6;">${vendorName}</b> | Category: ${p.category || 'Uncategorized'}
          </div>
          <div style="font-size:13px; color:#6b7280; margin-bottom:5px;">
            Submitted: ${p.submittedDate || (p.submittedAt ? new Date(p.submittedAt).toLocaleDateString() : 'Unknown')}
          </div>
        </div>

        <div style="background:#f9fafb; padding:12px; border-radius:8px; margin-bottom:15px;">
          <div style="font-weight:600; font-size:13px; color:#374151; margin-bottom:8px;">
            Variants (${safeVariants.length}):
          </div>
          <div style="display:flex; flex-wrap:wrap; gap:8px;">
            ${safeVariants.map(v => `
              <div style="background:white; padding:8px 12px; border-radius:6px; border:1px solid #e5e7eb; font-size:12px;">
                <b>${v.size}</b> ${v.color !== 'N/A' ? '<span style="color:#6b7280;">(' + v.color + ')</span>' : ''}<br>
                Vendor: ${VENDOR_CURRENCY} ${v.vendorPrice.toFixed(2)} | 
                Customer: ${VENDOR_CURRENCY} ${v.customerPrice.toFixed(2)} | 
                Stock: ${v.stock}
              </div>
            `).join('')}
          </div>
        </div>

        <div style="display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:10px;">
          <div style="font-size:14px;">
            <span style="color:#6b7280;">Your Commission:</span>
            <b style="color:#dc2626; font-size:18px;">
              ${commission > 0 ? VENDOR_CURRENCY + ' ' + commission.toFixed(2) + ' per unit' : 'N/A'}
            </b>
          </div>
          <div style="display:flex; gap:10px;">
            <button onclick="window.vendorAdmin.approveProduct('${p.id}')" 
              style="background:#10b981; color:white; border:none; padding:10px 20px; border-radius:8px; cursor:pointer; font-weight:600;">
              ✅ Approve & Push to Store
            </button>
            <button onclick="window.vendorAdmin.rejectProduct('${p.id}')" 
              style="background:#ef4444; color:white; border:none; padding:10px 20px; border-radius:8px; cursor:pointer; font-weight:600;">
              ❌ Reject
            </button>
          </div>
        </div>
      </div>
    `}).join('');
  }

  loadAllVendors() {
    const vendors = JSON.parse(localStorage.getItem('shopify_vendors') || '[]');
    const products = JSON.parse(localStorage.getItem('vendor_products') || '[]');
    const orders = JSON.parse(localStorage.getItem('vendor_orders') || '[]');
    
    const tbody = document.getElementById('vendors-table-body');
    if (!tbody) return;
    
    if (vendors.length === 0) {
      tbody.innerHTML = '<tr><td colspan="7" style="text-align:center; padding:30px; color:#9ca3af;">No vendors registered yet</td></tr>';
      return;
    }

    let html = '';
    vendors.forEach(v => {
      const vendorProducts = products.filter(p => p.vendorId === v.id && p.status === 'approved');
      const vendorOrders = orders.filter(o => o.vendorId === v.id);
      const totalSales = vendorOrders.reduce((sum, o) => sum + (parseFloat(o.total) || 0), 0);
      
      let statusStyle = '';
      if (v.status === 'approved') statusStyle = 'background:#dcfce7; color:#166534;';
      else if (v.status === 'pending') statusStyle = 'background:#fef3c7; color:#92400e;';
      else statusStyle = 'background:#fee2e2; color:#991b1b;';
      
      html += '<tr style="border-bottom:1px solid #e5e7eb;">';
      html += '<td style="padding:15px; font-weight:600; color:#1f2937;">' + (v.storeName || 'Unknown') + '</td>';
      html += '<td style="padding:15px; color:#6b7280; font-size:13px;">' + (v.email || 'N/A') + '</td>';
      html += '<td style="padding:15px; text-align:center; font-weight:600;">' + (v.commission || 0) + '%</td>';
      html += '<td style="padding:15px; text-align:center;"><span style="background:' + (vendorProducts.length > 0 ? '#dcfce7' : '#f3f4f6') + '; color:' + (vendorProducts.length > 0 ? '#166534' : '#6b7280') + '; padding:4px 12px; border-radius:20px; font-size:12px; font-weight:600;">' + vendorProducts.length + '</span></td>';
      html += '<td style="padding:15px; text-align:center; font-weight:600; color:#3b82f6;">' + VENDOR_CURRENCY + ' ' + totalSales.toFixed(2) + '</td>';
      html += '<td style="padding:15px; text-align:center;"><span style="padding:6px 14px; border-radius:20px; font-size:12px; font-weight:600; text-transform:uppercase; ' + statusStyle + '">' + (v.status || 'pending') + '</span></td>';
      html += '<td style="padding:15px; text-align:center;">';
      html += '<button onclick="window.vendorAdmin.viewVendorDetails(\'' + v.id + '\')" style="background:#3b82f6; color:white; border:none; padding:8px 16px; border-radius:6px; cursor:pointer; font-size:12px; font-weight:600; margin-right:5px;">View</button>';
      html += '<button onclick="window.vendorAdmin.deleteVendor(\'' + v.id + '\')" style="background:#ef4444; color:white; border:none; padding:8px 16px; border-radius:6px; cursor:pointer; font-size:12px; font-weight:600;">Delete</button>';
      html += '</td></tr>';
    });
    
    tbody.innerHTML = html;
  }

  // ==================== LOCAL PRODUCT DELETE ====================
  
  deleteLocalProduct(productId) {
    if (!confirm('⚠️ Warning: This will permanently delete this product from local storage.\n\nThis action cannot be undone. Continue?')) {
      return;
    }
    
    let products = JSON.parse(localStorage.getItem('vendor_products') || '[]');
    const productToDelete = products.find(p => p.id === productId);
    
    if (!productToDelete) {
      alert('Product not found in local storage');
      return;
    }
    
    products = products.filter(p => p.id !== productId);
    localStorage.setItem('vendor_products', JSON.stringify(products));
    
    console.log('Deleted local product:', productToDelete.title);
    alert(`✅ Product "${productToDelete.title || 'Untitled'}" deleted from local storage`);
    
    this.refreshData();
  }

  // ==================== PRODUCT APPROVAL & SHOPIFY SYNC ====================
  
  async approveProduct(productId) {
    let products = JSON.parse(localStorage.getItem('vendor_products') || '[]');
    const productIndex = products.findIndex(p => p.id === productId);
    
    if (productIndex === -1) {
      alert('Product not found');
      return;
    }
    
    const product = products[productIndex];
    
    const validImages = (product.images || []).filter(img => {
      return img && typeof img === 'string' && 
             (img.startsWith('http://') || img.startsWith('https://'));
    });
    
    if (validImages.length === 0) {
      alert('❌ Error: No valid image URLs found!\n\nThis product has no valid images. Please ask the vendor to upload images with proper URLs (starting with http:// or https://)\n\nAlternatively, you can delete this product and ask them to resubmit.');
      return;
    }
    
    if (validImages.length !== (product.images || []).length) {
      console.warn(`⚠️ Filtered out ${product.images.length - validImages.length} invalid images`);
    }
    
    if (!confirm(`Approve "${product.title}" with ${product.variants?.length || 0} variants?\n\nValid Images: ${validImages.length}\n\nThis will create the product in your Shopify store.`)) {
      return;
    }
    
    const btn = event.target;
    const originalText = btn.innerHTML;
    btn.innerHTML = '⏳ Creating in Shopify...';
    btn.disabled = true;
    
    try {
      const safeVariants = (product.variants || []).map((v, index) => ({
        option1: v.size || 'Default',
        option2: v.color && v.color !== 'N/A' ? v.color : null,
        price: (parseFloat(v.customerPrice) || 0).toString(),
        compare_at_price: null,
        sku: v.sku || (product.vendorId + '-' + Date.now() + '-' + index),
        inventory_quantity: parseInt(v.stock) || 0,
        inventory_management: 'shopify',
        requires_shipping: true,
        taxable: true
      }));

      const shopifyProduct = {
        product: {
          title: product.title || 'Untitled Product',
          body_html: product.description || product.title || '',
          vendor: product.vendorName || 'Unknown Vendor',
          product_type: product.category || 'General',
          tags: ['vendor-product', 'vendor-' + product.vendorId],
          variants: safeVariants,
          images: validImages.map(img => ({ src: img.trim() })),
          options: [
            { name: 'Size', values: [...new Set(safeVariants.map(v => v.option1))] }
          ]
        }
      };
      
      const colors = [...new Set((product.variants || [])
        .map(v => v.color)
        .filter(c => c && c !== 'N/A'))];
      
      if (colors.length > 0) {
        shopifyProduct.product.options.push({ name: 'Color', values: colors });
      }
      
      console.log('Creating Shopify product:', shopifyProduct);
      
      const response = await fetch(SYSTEM.BRIDGE, {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({
          auth_key: SYSTEM.AUTH,
          endpoint: '/products.json',
          method: 'POST',
          data: shopifyProduct
        })
      });
      
      const responseText = await response.text();
      console.log('Raw response:', responseText.substring(0, 500));
      
      let result;
      try {
        result = JSON.parse(responseText);
      } catch (e) {
        console.error('JSON parse error:', e);
        throw new Error('Invalid response from server: ' + responseText.substring(0, 100));
      }
      
      if (result.status === 'error' || result.errors) {
        const errorMsg = result.message || result.errors || 'Unknown error';
        throw new Error(errorMsg);
      }
      
      if (result.product && result.product.id) {
        products[productIndex].status = 'approved';
        products[productIndex].shopifyId = result.product.id;
        products[productIndex].shopifyHandle = result.product.handle;
        products[productIndex].approvedAt = new Date().toISOString();
        products[productIndex].adminUrl = `https://${window.Shopify?.shop || 'admin.shopify.com'}/admin/products/${result.product.id}`;
        
        localStorage.setItem('vendor_products', JSON.stringify(products));
        
        alert(`✅ Product Created Successfully in Shopify!\n\nTitle: ${result.product.title}\nShopify ID: ${result.product.id}\nHandle: ${result.product.handle}\nVariants: ${result.product.variants?.length || 0}`);
        
        this.refreshData();
      } else {
        throw new Error('Product created but no ID returned in response');
      }
      
    } catch (error) {
      console.error('Error creating product:', error);
      alert(`❌ Failed to create product in Shopify:\n\n${error.message}\n\nPossible reasons:\n1. Invalid image URLs (must be http/https)\n2. Missing required fields\n3. Shopify API error\n\nProduct will remain in pending state. You can delete it or try again.`);
    } finally {
      btn.innerHTML = originalText;
      btn.disabled = false;
    }
  }

  rejectProduct(productId) {
    if (!confirm('Reject this product? It will be deleted from local storage.')) return;
    
    let products = JSON.parse(localStorage.getItem('vendor_products') || '[]');
    products = products.filter(p => p.id !== productId);
    localStorage.setItem('vendor_products', JSON.stringify(products));
    
    this.refreshData();
  }

  // ==================== VENDOR MANAGEMENT ====================

  approveVendor(vendorId) {
    let vendors = JSON.parse(localStorage.getItem('shopify_vendors') || '[]');
    const vendor = vendors.find(v => v.id === vendorId);
    
    if (!vendor) return;
    
    if (!confirm(`Approve vendor "${vendor.storeName || 'Unknown'}" with ${vendor.commission || 0}% commission?`)) return;
    
    vendor.status = 'approved';
    vendor.approvedAt = new Date().toISOString();
    localStorage.setItem('shopify_vendors', JSON.stringify(vendors));
    
    alert(`✅ Vendor ${vendor.storeName || 'Unknown'} approved! They can now login and add products.`);
    this.refreshData();
  }

  rejectVendor(vendorId) {
    let vendors = JSON.parse(localStorage.getItem('shopify_vendors') || '[]');
    const vendor = vendors.find(v => v.id === vendorId);
    
    if (!vendor) return;
    
    if (!confirm(`Reject and delete vendor "${vendor.storeName || 'Unknown'}"?`)) return;
    
    vendors = vendors.filter(v => v.id !== vendorId);
    localStorage.setItem('shopify_vendors', JSON.stringify(vendors));
    
    this.refreshData();
  }

  deleteVendor(vendorId) {
    const vendors = JSON.parse(localStorage.getItem('shopify_vendors') || '[]');
    const vendor = vendors.find(v => v.id === vendorId);
    
    if (!vendor) {
      alert('Vendor not found');
      return;
    }
    
    const products = JSON.parse(localStorage.getItem('vendor_products') || '[]');
    const vendorProducts = products.filter(p => p.vendorId === vendorId && p.status === 'approved');
    
    let msg = 'Delete vendor "' + (vendor.storeName || 'Unknown') + '"?';
    if (vendorProducts.length > 0) {
      msg += '\n\n⚠️ This vendor has ' + vendorProducts.length + ' approved products in Shopify. Delete those manually first!';
    }
    
    if (!confirm(msg)) return;
    
    const updatedVendors = vendors.filter(v => v.id !== vendorId);
    localStorage.setItem('shopify_vendors', JSON.stringify(updatedVendors));
    
    if (confirm('Also delete pending products from this vendor?')) {
      const updatedProducts = products.filter(p => p.vendorId !== vendorId || p.status === 'approved');
      localStorage.setItem('vendor_products', JSON.stringify(updatedProducts));
    }
    
    alert('Vendor deleted');
    this.refreshData();
  }

  // ==================== EDIT COMMISSION (NEW FEATURE) ====================
  
  updateVendorCommission(vendorId) {
    const input = document.getElementById(`commission-${vendorId}`);
    if (!input) return;
    
    const newCommission = parseFloat(input.value);
    if (isNaN(newCommission) || newCommission < 0 || newCommission > 100) {
      alert('Please enter a valid commission percentage (0-100)');
      return;
    }
    
    let vendors = JSON.parse(localStorage.getItem('shopify_vendors') || '[]');
    const vendorIndex = vendors.findIndex(v => v.id === vendorId);
    
    if (vendorIndex === -1) {
      alert('Vendor not found');
      return;
    }
    
    const oldCommission = vendors[vendorIndex].commission;
    vendors[vendorIndex].commission = newCommission;
    vendors[vendorIndex].updatedAt = new Date().toISOString();
    
    localStorage.setItem('shopify_vendors', JSON.stringify(vendors));
    
    alert(`✅ Commission updated from ${oldCommission}% to ${newCommission}% for ${vendors[vendorIndex].storeName || 'Vendor'}`);
    
    // Refresh all views
    this.refreshData();
    
    // Re-open vendor details to show updated value
    this.viewVendorDetails(vendorId);
  }

  // ==================== STATS & UI ====================

  updateStats() {
    const vendors = JSON.parse(localStorage.getItem('shopify_vendors') || '[]');
    const products = JSON.parse(localStorage.getItem('vendor_products') || '[]');
    const orders = JSON.parse(localStorage.getItem('vendor_orders') || '[]');
    
    const pendingVendors = vendors.filter(v => v.status === 'pending').length;
    const pendingProducts = products.filter(p => p.status === 'pending').length;
    const approvedProducts = products.filter(p => p.status === 'approved').length;
    const totalSales = orders.reduce((sum, o) => sum + (parseFloat(o.total) || 0), 0);
    const totalCommission = orders.reduce((sum, o) => sum + (parseFloat(o.commission) || 0), 0);
    
    const setText = (id, value) => {
      const el = document.getElementById(id);
      if (el) el.textContent = value;
    };
    
    setText('stat-total-vendors', vendors.length);
    setText('stat-pending-vendors', pendingVendors);
    setText('stat-vendor-products', approvedProducts);
    setText('stat-pending-products', pendingProducts);
    setText('stat-commission-due', totalCommission.toFixed(2) + ' ' + VENDOR_CURRENCY);
    setText('stat-vendor-sales', totalSales.toFixed(2) + ' ' + VENDOR_CURRENCY);
  }

  updateVendorBadge(count) {
    const badge = document.getElementById('vendor-pending-badge');
    if (badge) {
      badge.style.display = count > 0 ? 'inline-block' : 'none';
      badge.textContent = count;
    }
  }

  viewVendorDetails(vendorId) {
    const vendors = JSON.parse(localStorage.getItem('shopify_vendors') || '[]');
    const vendor = vendors.find(v => v.id === vendorId);
    if (!vendor) return;
    
    const products = JSON.parse(localStorage.getItem('vendor_products') || '[]');
    const orders = JSON.parse(localStorage.getItem('vendor_orders') || '[]');
    
    const vendorProducts = products.filter(p => p.vendorId === vendorId && p.status === 'approved');
    const vendorOrders = orders.filter(o => o.vendorId === vendorId);
    const pendingPayout = vendorOrders.filter(o => !o.paid).reduce((sum, o) => sum + (parseFloat(o.vendorEarning) || 0), 0);
    const totalPaid = vendorOrders.filter(o => o.paid).reduce((sum, o) => sum + (parseFloat(o.vendorEarning) || 0), 0);
    
    const container = document.getElementById('payout-list');
    if (!container) return;
    
    let html = '<div style="background:#f9fafb; padding:25px; border-radius:12px; border:2px solid #e5e7eb;">';
    html += '<h3 style="margin:0 0 10px 0;">' + (vendor.storeName || 'Unknown') + '</h3>';
    html += '<p style="margin:0 0 20px 0; color:#6b7280;">' + (vendor.email || 'N/A') + ' | ' + (vendor.phone || 'N/A') + '</p>';
    
    // ✅ COMMISSION EDIT SECTION
    html += '<div style="background:white; padding:15px; border-radius:8px; margin-bottom:20px; border:2px solid #3b82f6;">';
    html += '<div style="font-weight:600; margin-bottom:10px; color:#1f2937;">Commission Rate</div>';
    html += '<div style="display:flex; gap:10px; align-items:center;">';
    html += '<input type="number" id="commission-' + vendorId + '" value="' + (vendor.commission || 15) + '" min="0" max="100" step="0.5" style="width:80px; padding:8px; border:2px solid #e5e7eb; border-radius:6px; font-size:16px; font-weight:600;">';
    html += '<span style="font-size:18px; font-weight:700;">%</span>';
    html += '<button onclick="window.vendorAdmin.updateVendorCommission(\'' + vendorId + '\')" style="background:#3b82f6; color:white; border:none; padding:8px 16px; border-radius:6px; cursor:pointer; font-weight:600; margin-left:auto;">Update Commission</button>';
    html += '</div>';
    html += '<div style="font-size:12px; color:#6b7280; margin-top:5px;">Changes will apply to all future orders</div>';
    html += '</div>';
    
    html += '<div style="display:grid; grid-template-columns:repeat(2, 1fr); gap:15px; margin-bottom:20px;">';
    html += '<div style="background:white; padding:15px; border-radius:8px; text-align:center;"><div style="font-size:24px; font-weight:800; color:#3b82f6;">' + vendorProducts.length + '</div><div style="font-size:12px; color:#6b7280;">Products</div></div>';
    html += '<div style="background:white; padding:15px; border-radius:8px; text-align:center;"><div style="font-size:24px; font-weight:800; color:#f59e0b;">' + VENDOR_CURRENCY + ' ' + pendingPayout.toFixed(2) + '</div><div style="font-size:12px; color:#6b7280;">Pending</div></div>';
    html += '</div>';
    
    if (pendingPayout > 0) {
      html += '<div style="background:#fef3c7; border:2px solid #f59e0b; padding:15px; border-radius:8px; margin-bottom:15px;">';
      html += '<div style="font-weight:bold; color:#92400e; margin-bottom:10px;">Payment Due: ' + VENDOR_CURRENCY + ' ' + pendingPayout.toFixed(2) + '</div>';
      html += '<button onclick="window.vendorAdmin.markAsPaid(\'' + vendorId + '\')" style="width:100%; background:#10b981; color:white; border:none; padding:10px; border-radius:6px; cursor:pointer; font-weight:600;">Mark as Paid</button>';
      html += '</div>';
    }
    
    html += '<button onclick="window.vendorAdmin.deleteVendor(\'' + vendorId + '\')" style="width:100%; background:#ef4444; color:white; border:none; padding:10px; border-radius:6px; cursor:pointer; font-weight:600;">Delete Vendor</button>';
    html += '</div>';
    
    container.innerHTML = html;
  }

  markAsPaid(vendorId) {
    if (!confirm('Confirm payment received?')) return;
    
    let orders = JSON.parse(localStorage.getItem('vendor_orders') || '[]');
    const now = new Date().toISOString();
    
    orders = orders.map(o => {
      if (o.vendorId === vendorId && !o.paid) {
        return { ...o, paid: true, paidAt: now };
      }
      return o;
    });
    
    localStorage.setItem('vendor_orders', JSON.stringify(orders));
    alert('✅ Marked as paid!');
    this.viewVendorDetails(vendorId);
    this.updateStats();
  }
}

// Global Functions
window.initVendorModule = function() {
  if (!window.vendorAdmin) {
    window.vendorAdmin = new VendorAdmin();
  } else {
    window.vendorAdmin.refreshData();
  }
};

window.refreshVendors = function() {
  if (window.vendorAdmin) window.vendorAdmin.loadPendingVendors();
};

window.refreshVendorProducts = function() {
  if (window.vendorAdmin) window.vendorAdmin.loadPendingProducts();
};